import { createSelector } from 'reselect'
import { Account, Wallet } from './types'
import { WALLET_TYPES } from '~/types'
import { ConfigManager, COUNTRY } from '~/managers/ConfigManager'
import { RootState } from '~/biz/store/types'

const selectAccounts = (accounts: Account[]) => accounts

const selectFeatureMatrix = (state: RootState) => state.route.featureMatrix
const selectSandbox = (state: RootState) => state.sandbox.isSandbox

export const getFeatureMatrixFactors = createSelector(
  [selectFeatureMatrix, selectSandbox],
  (featureMatrix, isSandbox) => ({
    isSandbox,

    role: featureMatrix.userRole,
    isId: featureMatrix.country === COUNTRY.INDONESIA,
    isSg: featureMatrix.country === COUNTRY.SINGAPORE,

    isBizVerified: featureMatrix.businessVerificationStatus === 'verified',
    isPersVerified: featureMatrix.personalVerificationStatus === 'verified',
    isPersIdentified: featureMatrix.isIdentificationDone,
    isExceed20k: featureMatrix.companyTxnVolume > 20000,

    hasGW: featureMatrix.availableWallets?.includes(WALLET_TYPES.GENERAL),
    hasDGW: featureMatrix.availableWallets?.includes(WALLET_TYPES.DIGITAL_GOODS),

    hasFundPoolForIdDisbursement:
      featureMatrix.availableFundPools?.includes(1) ||
      featureMatrix.availableFundPools?.includes(3),
    hasFundPoolForIdWithdraw:
      featureMatrix.availableFundPools?.includes(2) ||
      featureMatrix.availableFundPools?.includes(1) ||
      featureMatrix.availableFundPools?.includes(3),

    isHighRiskMerchant: featureMatrix.isHighRiskMerchant,
  })
)

export const checkDigitalGoodsExist = createSelector([selectAccounts], accounts => {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const walletIds = accounts.map((acc: any) => acc.id)
  return walletIds.includes(2)
})

export const selectUserWallets = createSelector([selectAccounts], accounts => {
  const wallets: Wallet[] = accounts.map((acc: any) => {
    let label: string

    if (acc.id === WALLET_TYPES.GENERAL) {
      label = `General ${ConfigManager.getCountry() === COUNTRY.INDONESIA ? 'Funds' : 'Wallet'}`
    } else if (acc.id === WALLET_TYPES.DIGITAL_GOODS) {
      label = `Digital Goods ${
        ConfigManager.getCountry() === COUNTRY.INDONESIA ? 'Funds' : 'Wallet'
      }`
    } else {
      label = 'Account withdraw not supported yet, its probably a bug'
    }

    return {
      label,
      type: acc.id,
      balance: acc.balance,
      formattedBalance: acc.formattedBalance,
      accountId: acc.accountId,
      accountType: acc.type,
      fundPoolId: acc.fundPoolId,
      accountConfiguration: acc?.accountConfiguration,
    }
  })

  return wallets
})
